// The answer document's envelope. Section groups are created on demand, keyed
// by the `section.key` / `field.key` the server sends, so a new section needs
// no change here.
export const emptyDoc = () => ({
  submitted: false,
  // Closed by the deadline, 30 days before the wedding. Server owned: it is
  // refreshed from the payload on every load.
  locked: false,
  acknowledged: false,
  revision: 0,
  current_section: null,
  section_updated_at: {},
});

// Answer groups are absent until touched, so every read goes through these.
export const groupOf = (doc, sectionKey) => doc[sectionKey] || {};

export const valueOf = (doc, sectionKey, fieldKey, fallback) => {
  const v = groupOf(doc, sectionKey)[fieldKey];
  return v === undefined || v === null ? fallback : v;
};
